module.exports = __webpack_public_path__ + "img/30.739e05df.png";